import ApiInstance from "./ApiInstance";

export interface CalendarStatus {
  configured: { google: boolean; microsoft: boolean };
  connection: { provider: "google" | "microsoft"; connectedAt?: string } | null;
}

class CalendarApi {
  async status(): Promise<CalendarStatus> {
    const { data } = await ApiInstance.getApi().get("/calendar/status");
    return data;
  }
  async connect(provider: "google" | "microsoft"): Promise<{ url: string }> {
    const { data } = await ApiInstance.getApi().post(`/calendar/connect/${provider}`, {});
    return data;
  }
  async disconnect(): Promise<void> {
    await ApiInstance.getApi().post("/calendar/disconnect", {});
  }
}

const calendarApi = new CalendarApi();
export default calendarApi;
